import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { generatePath } from 'react-router';
import { routes } from '$src/routes';

import useLocationContext from '$src/hooks/useLocationContext';

import Devices from '../Devices';
import EventSummary from '../EventSummary';
import PrivateGuard from '../PrivateGuard';
import Preferences from '../Preferences';
import TrialManagement from '../FreeTrial/TrialManagement';
import TrialBenefits from '../FreeTrial/TrialBenefits';

const PAGE_ROUTE_MAP = {
  // Preserve this legacy deep link even if the default settings route changes.
  'ring-guard': 'eventSummary',
};

function SettingsItems() {
  const locationId = useLocationContext();
  const { search } = useLocation();
  const page = new URLSearchParams(search).get('page');
  const routeKey = PAGE_ROUTE_MAP[page];
  const defaultRoute = routeKey ? routes[routeKey] : routes.eventSummary;

  return (
    <Switch>
      <Route
        exact
        path={routes.settings}
        render={() => (
          <Redirect
            to={{
              pathname: generatePath(defaultRoute, { locationId }),
              state: { sider: true },
            }}
          />
        )}
      />
      <Route path={routes.eventSummary} render={() => <EventSummary />} />
      <Route path={routes.privateGuard} render={() => <PrivateGuard />} />
      <Route path={routes.alerts} render={() => <Preferences />} />
      <Route path={routes.devices} render={() => <Devices />} />
      <Route path={routes.trialBenefits} render={() => <TrialBenefits />} />
      <Route path={routes.trialManagement} render={() => <TrialManagement />} />
      <Route render={() => <Redirect to="/not-found" />} />
    </Switch>
  );
}

export default SettingsItems;
